import { render } from "./ThemeScoreDum.vue?vue&type=template&id=c62837e0"
import script from "./ThemeScoreDum.vue?vue&type=script&lang=js"
export * from "./ThemeScoreDum.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__